import { useEffect, useState } from "react";
import { Alert } from "antd";
import ApiArticles from "../../../../api/articles";
import { collectArticleIds, unavailableLines } from "../utils/article-references";

// LF360-2016 — the articles in this graph's Suggestions that the editor shows as
// a bare id, by name and with the reason. The node itself still shows the id
// (that is the scenario-designer package's to change); this is so the admin
// can see which article it was and why, and replace it there.
const UnavailableArticlesNotice = ({ graph }) => {
  const ids = collectArticleIds(graph);
  const key = [...ids].sort().join(",");
  const [lines, setLines] = useState([]);

  useEffect(() => {
    let cancelled = false;

    if (!key) {
      setLines([]);
      return undefined;
    }

    ApiArticles.referenceStates(key.split(","))
      .then(({ data }) => {
        if (!cancelled) setLines(unavailableLines(data?.references));
      })
      // A notice is a convenience: failing to load one changes nothing else.
      .catch(() => {
        if (!cancelled) setLines([]);
      });

    return () => {
      cancelled = true;
    };
  }, [key]);

  if (!lines.length) return null;

  return (
    <Alert
      className="scenario-unavailable-articles"
      type="warning"
      showIcon
      message="Some articles in Suggestions are not available. Remove or replace them there:"
      description={
        <ul className="scenario-unavailable-articles__list">
          {lines.map((line) => (
            <li key={line.id}>
              {line.title ? <strong>{line.title}</strong> : <span>An article deleted before its name was kept</span>}
              {" — "}
              {line.reason}
            </li>
          ))}
        </ul>
      }
    />
  );
};

export default UnavailableArticlesNotice;
